import axios from "axios";
import { useRouter } from "next/router";
import React, { useState, useEffect } from "react";
import swal from "sweetalert";
import UnbxdProductCardResult from "../../../src/UnbxdProductCardResult";
import { savePincode } from "../../../api.services.js/others";
import cookie from "js-cookie";
import { parse } from "cookie";

export const getServerSideProps = async (context) => {
  const cookies = parse(context.req.headers.cookie || "");
  if (!context.query.q) {
    return {
      redirect: {
        destination: `/404`,
        permanent: false,
      },
    };
  }
  let unBxdUrl = `https://search.unbxd.io/5a4b9251b67027ff94d260e4ac6ac09e/ss-unbxd-aapac-prod-orientbell53741713874410/search?rows=9&page=1&q=${context.query.q}&facet=true&selectedfacet=true&facet.multiselect=true&fields=productUrl%2CimageUrl%2Ctitle%2Cprice%2CtileSize%2Csku%2CtileFactoryProduction%2ChoskoteStock%2CwestZoneStock%2CdoraStock%2CskdStock`;
  let unBxdUrl2 = `https://search.unbxd.io/5a4b9251b67027ff94d260e4ac6ac09e/ss-unbxd-aapac-prod-orientbell53741713874410/search?&page=1&q=${context.query.q}&facet=true&selectedfacet=true&facet.multiselect=true&fields=productUrl%2CimageUrl%2Ctitle%2Cprice%2CtileSize%2Csku%2CtileFactoryProduction%2ChoskoteStock%2CwestZoneStock%2CdoraStock%2CskdStock`;

  const { data } = await axios.get(unBxdUrl, {
    headers: { "unbxd-user-id": cookies["unbxd.userId"] },
  });
  if (data?.redirect?.value) {
    return {
      redirect: {
        destination: data?.redirect?.value,
        permanent: false,
      },
    };
  }
  return {
    props: { data, q: context.query.q, unBxdUrl: unBxdUrl2 },
  };
};
const SearchResult = (props) => {
  const router = useRouter();
  const [products, setProducts] = useState();
  const [perPage, setPerPage] = useState(9);
  const [currentStart, setCurrentStart] = useState(0);

  const [TotalProd, setTotalProd] = useState(0);
  const [SortBy, setSortBy] = useState("*");
  const [mobileViewFilter, setMobileViewFilter] = useState(false);
  const [loadmore, setloadmore] = useState([]);
  const [pincode, setPinCode] = useState("");
  const [Statee, setStatee] = useState("");

  const [facets, setfacets] = useState(props.data.facets);
  const [AppliedFacet, setAppliedFacet] = useState({});

  let GetState = async (pin) => {
    let pinInfo = await axios.post(`https://api.floraindia.com/api/zipinfo`, {
      pincode: pin,
    });
    if (pinInfo?.data?.data?.PostOffice?.length > 0) {
      setStatee(pinInfo?.data?.data?.PostOffice[0].State);
    }
  };
  useEffect(() => {
    setProducts(props.data.response.products);
    setTotalProd(props.data.response.numberOfProducts);
    if (cookie.get("pincode")) {
      setPinCode(cookie.get("pincode"));
    }
    if (cookie.get("pincode")) {
      GetState(cookie.get("pincode"));
    }
  }, []);
  const getResultwithFacet = async (key, value, checked) => {
    const result = {};
    let newArr = AppliedFacet[key]
      ? [...AppliedFacet[key]].filter((cc) => cc !== value)
      : [];
    if (checked) newArr.push(value);

    const updatedFacets = { ...AppliedFacet, [key]: newArr };
    for (const [k, v] of Object.entries(updatedFacets)) {
      if (v?.length) result[k] = v;
    }

    setAppliedFacet(result);
    setCurrentStart(0); // reset pagination

    const urlObj = new URL(props.unBxdUrl);
    Object.entries(result).forEach(([k, v]) => {
      const encoded =
        v.length > 1 ? v.map((f) => `${k}:"${f}"`).join(" OR ") : `${k}:"${v}"`;
      urlObj.searchParams.append("filter", encoded);
    });

    urlObj.searchParams.append("rows", perPage);
    urlObj.searchParams.append("start", 0); // reset to 0
    if (SortBy !== "*") urlObj.searchParams.append("sort", SortBy);

    try {
      const response = await axios.get(urlObj.toString(), {
        headers: { "unbxd-user-id": cookie.get("unbxd.userId") },
      });
      setProducts(response.data.response.products);
      setTotalProd(response.data.response.numberOfProducts);
    } catch (error) {
      console.log("error");
      swal("Something went wrong please try again later");
    }

    // console.log(urlObj.toString());
  };

  const loadMore = async () => {
    const result = {};
    for (const [k, v] of Object.entries(AppliedFacet)) {
      if (v?.length) result[k] = v;
    }

    const nextStart = currentStart + perPage;

    const urlObj = new URL(props.unBxdUrl);
    Object.entries(result).forEach(([k, v]) => {
      const encoded =
        v.length > 1 ? v.map((f) => `${k}:"${f}"`).join(" OR ") : `${k}:"${v}"`;
      urlObj.searchParams.append("filter", encoded);
    });

    urlObj.searchParams.append("rows", perPage);
    urlObj.searchParams.append("start", nextStart);
    if (SortBy !== "*") urlObj.searchParams.append("sort", SortBy);

    try {
      const response = await axios.get(urlObj.toString(), {
        headers: { "unbxd-user-id": cookie.get("unbxd.userId") },
      });
      setProducts((prev) => [...prev, ...response.data.response.products]);
      setTotalProd(response.data.response.numberOfProducts);
      setCurrentStart(nextStart); // update for next loadMore
    } catch (error) {
      console.log("error");
      swal("Something went wrong please try again later");
    }

    // console.log(urlObj.toString());
  };

  const applysort = async (s) => {
    const result = {};
    for (const [k, v] of Object.entries(AppliedFacet)) {
      if (v?.length) result[k] = v;
    }

    setSortBy(s);
    setCurrentStart(0); // reset
    const urlObj = new URL(props.unBxdUrl);

    Object.entries(result).forEach(([k, v]) => {
      const encoded =
        v.length > 1 ? v.map((f) => `${k}:"${f}"`).join(" OR ") : `${k}:"${v}"`;
      urlObj.searchParams.append("filter", encoded);
    });

    urlObj.searchParams.append("rows", perPage);
    urlObj.searchParams.append("start", 0);
    if (s !== "*") urlObj.searchParams.append("sort", s);

    try {
      const response = await axios.get(urlObj.toString(), {
        headers: { "unbxd-user-id": cookie.get("unbxd.userId") },
      });
      setProducts(response.data.response.products);
      setTotalProd(response.data.response.numberOfProducts);
    } catch (error) {
      console.log("error");
      swal("Something went wrong please try again later");
    }

    // console.log(urlObj.toString());
  };

  const handleMobileFilter = () => {
    if (mobileViewFilter) {
      setMobileViewFilter(false);
    } else {
      setMobileViewFilter(true);
    }
  };
  const handlePinCodeChangeInput = (e) => {
    setPinCode(e.target.value);
    const pincode = e.target.value * 1;
    if (e.target.value.length == 6) {
      savePincode({ pincodedetails: pincode });
      cookie.set("pincode", pincode, { expires: 7 });
      localStorage.setItem("pincode", pincode);
      localStorage.setItem("pincodeSkip", true);
      router.reload();
    }
  };
  return (
    <div className="obl-searchresult-section">
      <div className="select-location-wrapper">
        <span>TO FIND PRICES IN YOUR CITY, ENTER YOUR PINCODE</span>
        <span className="select-wraper">
          <input
            value={pincode}
            onChange={(e) => handlePinCodeChangeInput(e)}
          ></input>
        </span>
      </div>
      <div className="container">
        <div class="obl-searchresult-row">
          <div class="obl-searchresult-left">
            <div className="mobile_view_filter" onClick={handleMobileFilter}>
              <h3>- Refine</h3>
            </div>
            <div
              className={
                mobileViewFilter
                  ? "obl-searchresult-div filter-active"
                  : "obl-searchresult-div"
              }
            >
              <div class="ClearRefinements">
                <button class="all-clear-btn" onClick={() => router.reload()}>
                  Clear all
                </button>
              </div>
              {facets?.text?.list?.map((face) => {
                return (
                  <div class="searchresult-filter color">
                    <p class="title-bx">{face.displayName}</p>
                    <div class="ais-HierarchicalMenu">
                      <ul class="ais-RefinementList-list">
                        {loadmore.includes(face.displayName) &&
                        face.values.filter((f) => typeof f != "number").length >
                          3 ? (
                          face.values
                            .filter((f) => typeof f != "number")
                            .map((cc) => {
                              return (
                                <li
                                  className={`ais-RefinementList-item ${
                                    AppliedFacet[face.facetName]?.includes(cc)
                                      ? "selected"
                                      : ""
                                  }`}
                                >
                                  <label class="ais-RefinementList-label">
                                    <input
                                      class="ais-RefinementList-checkbox"
                                      type="checkbox"
                                      onChange={(e) => {
                                        if (e.target.checked) {
                                          getResultwithFacet(
                                            face.facetName,
                                            cc,
                                            true
                                          );
                                        } else {
                                          getResultwithFacet(
                                            face.facetName,
                                            cc,
                                            false
                                          );
                                        }
                                      }}
                                      checked={
                                        AppliedFacet[face.facetName]?.length
                                          ? AppliedFacet[
                                              face.facetName
                                            ].includes(cc)
                                          : false
                                      }
                                    />
                                    <span class="ais-RefinementList-labelText">
                                      {cc}
                                    </span>
                                  </label>
                                </li>
                              );
                            })
                        ) : (
                          <>
                            {face.values
                              .filter((f) => typeof f != "number")
                              .slice(0, 3)
                              .map((cc) => {
                                return (
                                  <li
                                    className={`ais-RefinementList-item ${
                                      AppliedFacet[face.facetName]?.includes(cc)
                                        ? "selected"
                                        : ""
                                    }`}
                                  >
                                    <label class="ais-RefinementList-label">
                                      <input
                                        class="ais-RefinementList-checkbox"
                                        type="checkbox"
                                        onChange={(e) => {
                                          if (e.target.checked) {
                                            getResultwithFacet(
                                              face.facetName,
                                              cc,
                                              true
                                            );
                                          } else {
                                            getResultwithFacet(
                                              face.facetName,
                                              cc,
                                              false
                                            );
                                          }
                                        }}
                                        checked={
                                          AppliedFacet[face.facetName]?.length
                                            ? AppliedFacet[
                                                face.facetName
                                              ].includes(cc)
                                            : false
                                        }
                                      />
                                      <span class="ais-RefinementList-labelText">
                                        {cc}
                                      </span>
                                    </label>
                                  </li>
                                );
                              })}
                            {face.values.filter((f) => typeof f != "number")
                              .length > 3 && (
                              <p
                                onClick={() => {
                                  setloadmore([...loadmore, face.displayName]);
                                }}
                                style={{
                                  color: "blue",
                                  marginBottom: "0px !important",
                                }}
                              >
                                load more
                              </p>
                            )}
                          </>
                        )}
                      </ul>
                      {/* <p>+load more</p> */}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <div class="obl-searchresult-right">
            <div className="obl-searchresult-heading">
              <h1>
                Results for{" "}
                {props.data?.searchMetaData?.fallback?.q
                  ? props.data?.searchMetaData?.fallback?.q
                  : props.q}
              </h1>
              <p>Check each product page for other buying options.</p>
              <div className="searchresult-sort-bx">
                <select
                  value={SortBy}
                  onChange={(e) => {
                    applysort(e.target.value);
                  }}
                >
                  <option value="*">Relevance</option>
                  <option value="price desc">Price (high to low)</option>
                  <option value="price asc">Price (low to high)</option>
                </select>
              </div>
              {Statee && (
                <div class="amshopby-filter">
                  <ul>
                    <li
                      onClick={() => {
                        setStatee("");
                        cookie.remove("pincode");
                        localStorage.removeItem("pincode");
                        router.reload();
                      }}
                    >
                      {Statee}
                      <button>X</button>
                    </li>
                  </ul>
                </div>
              )}
            </div>
            <div className="obl-searchresult-row">
              {products?.length > 0 &&
                products.map((prod, ii) => {
                  return <UnbxdProductCardResult product={prod} />;
                })}
            </div>
            <div class="load-more-product">
              {TotalProd != products?.length && (
                <button type="button" onClick={() => loadMore()}>
                  Load More from {TotalProd - products?.length}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchResult;
